export default "__VITE_ASSET__CvbPWWix__"